<template>    
    <v-row class="h-100 vrow-border">
        <v-col class="flex-col-center no-pd" xs="12" sm="12" md="6" lg="6" xl="6">
            <v-form class="h-100 w-50 d-flex flex-auto flex-column justify-center" v-model="validation">
                <span class="screen__text"> Nova senha </span>
                <v-text-field
                    class="password__input"
                    color="var(--cor--preta)"
                    placeholder="**********"
                    v-model="newPassword"
                    :type=" ShowNewPassword? 'text' : 'password'"
                    :append-icon="ShowNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="ShowNewPassword = !ShowNewPassword"
                    @change="$v.newPassword.$touch()"
                    @blur="$v.newPassword.$touch()"
                    :error-messages="newPasswordErrors"
                ></v-text-field>

                <v-text-field
                    class="password__input"
                    color="var(--cor--preta)"
                    placeholder="**********"
                    v-model="confirmNewPassword"
                    :type=" ShowConfirmPassword? 'text' : 'password'"
                    :append-icon="ShowConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="ShowConfirmPassword = !ShowConfirmPassword"
                    @change="$v.confirmNewPassword.$touch()"
                    @blur="$v.confirmNewPassword.$touch()"
                    :error-messages="confirmNewPasswordErros"
                ></v-text-field>

                <v-btn :color="currentCompany.buttonsColor" class="custom-btn btn--mg text-white"  @click="verifyPassword()" :disabled="!validation" :loading="btnLoading">
                    <v-icon v-if="!validation" size="16" left> mdi-lock </v-icon>
                    <span class="text-none text-white"> Mudar senha </span>
                </v-btn>
            </v-form>
        </v-col>

        <v-col class="external__container flex-row-center" xs="12" sm="12" md="6" lg="6" xl="6" :style="`background-color: ${this.currentCompany.primaryColor}`" v-if="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl">
            <v-avatar size="60">
                <img :src="companyImage? companyImage : defaultUserImage">
            </v-avatar>
            <span class="company__name screen__text" style="font-size: 20px"> {{currentCompany.name}} </span>
        </v-col>
    </v-row>
</template>

<script>
//Store
import { mapGetters } from "vuex";

//Validation
import { required } from "vuelidate/lib/validators";

//Function
import { passwordRule } from "@/support/functions/validation.function";

//Services
import { updatePasswordByRecoverUniqueId } from "./service/create-password.service";

export default {
    name: 'CreatePassword',
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany',
                companyImage: 'get_currentCompanyImage',
            }
        ),
        defaultUserImage() {
            return require('@/assets/default-user-intern.png')
        },
        newPasswordErrors() {
            const errors = []
            if (!this.$v.newPassword.$dirty) return errors
            !this.$v.newPassword.required && errors.push('Senha é obrigatória.')
            !this.$v.newPassword.passwordRule && errors.push('Esta senha não é válida.')
            return errors
        },
        confirmNewPasswordErros() {
            const errors = []
            if (!this.$v.confirmNewPassword.$dirty) return errors
            !this.$v.confirmNewPassword.required && errors.push('Confirmação é obrigatória.')
            !this.$v.confirmNewPassword.passwordRule && errors.push('Confirmação não é válida.')
            return errors
        }
    },
    data: () => ({
        newPassword: '',
        confirmNewPassword: '',
        ShowNewPassword: false,
        ShowConfirmPassword: false,
        btnLoading: false,
        validation: false
    }),
    validations: {
        newPassword: { required, passwordRule},
        confirmNewPassword: { required, passwordRule}
    },
    methods: {
        verifyPassword() {
            if( this.newPassword === this.confirmNewPassword && (this.newPassword != '' && this.newPassword != null) ) this.changePassword()
            else if( this.newPassword == '' ) {
                this.$v.newPassword.$touch()
                this.$v.confirmNewPassword.$touch()
            }
            else {
                this.confirmNewPassword = ''
                this.$v.confirmNewPassword.$touch()
                this.$toasted.show('Cofirmação precisa ser igual a senha!', { type: 'error' })
            }
        },
        changePassword() {
            this.btnLoading = true
            updatePasswordByRecoverUniqueId( this.newPassword, this.$route.query.uniqueId )
                .then( success => {
                        this.btnLoading = false
                        this.$router.push('/login')
                    }
                )
                .catch( error => {
                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                        this.btnLoading = false
                    }
                )
        }
    }
}
</script>

<style scoped>
.password__input {
    max-height: 70px;
}
.company__name {
    margin-left: 10px;
}
.screen__text {
    font-family: 'Nunito', sans-serif;
    font-size: 18px;
    font-weight: bold;
}
.btn--mg {
    margin-top: 10px;
}
.vrow-border {
    border-top: 1px solid #c9c9c9 !important;
}
</style>